<template>
  <slot />
</template>
<script setup lang="ts">
import { provide } from 'vue';
import { Drawer } from './drawer';
import { drawerKey } from './drawer-key';

const props = defineProps<{ drawer: Drawer }>();
provide(drawerKey, props.drawer);
</script>
